var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_54_1022)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.79163 14.6766V18.5416C7.79227 18.673 7.83422 18.8008 7.91154 18.907C7.98886 19.0132 8.09764 19.0923 8.22245 19.1332C8.34727 19.1742 8.4818 19.1748 8.60699 19.135C8.73217 19.0952 8.84167 19.0171 8.91997 18.9116L11.1808 15.8349L7.79163 14.6766ZM20.2375 0.115773C20.1436 0.0489012 20.033 0.00930478 19.918 0.00136298C19.803 -0.00657883 19.688 0.0174435 19.5858 0.0707732L0.8358 9.86244C0.727918 9.91946 0.63903 10.0067 0.580042 10.1135C0.521055 10.2204 0.494535 10.3421 0.503738 10.4637C0.512941 10.5854 0.557466 10.7018 0.631849 10.7985C0.706232 10.8952 0.807236 10.9681 0.922467 11.0083L6.13497 12.7899L17.2358 3.29827L8.6458 13.6474L17.3816 16.6333C17.4683 16.6624 17.5603 16.6722 17.6512 16.6621C17.7421 16.6519 17.8296 16.622 17.9078 16.5744C17.9859 16.5269 18.0526 16.4628 18.1034 16.3868C18.1542 16.3107 18.1877 16.2245 18.2016 16.1341L20.4933 0.71744C20.5103 0.603315 20.4953 0.486722 20.4502 0.380543C20.405 0.274364 20.3314 0.182733 20.2375 0.115773Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_1022"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessageIcon);
export default __webpack_public_path__ + "static/media/sendMessageIcon.a25cb39f5370391b69924fc75954ab92.svg";
export { ForwardRef as ReactComponent };